// src/MemberCard.jsx
const EXCLUDE_KEYS = new Set(["id", "name", "portrait", "bio", "health"]);

function toLabel(key) {
  // Keep original case but make snake/kebab readable if you ever add them
  return String(key)
    .replace(/[_-]+/g, " ")
    .replace(/\b\w/g, (c) => c.toUpperCase());
}

export default function MemberCard({ member }) {
  const stats = Object.entries(member)
    .filter(([key, value]) => !EXCLUDE_KEYS.has(key) && typeof value === "number")
    // optional: sort stats by value desc, or keep insertion order
    // .sort((a, b) => b[1] - a[1])
    .map(([key, value]) => ({
      key,
      label: toLabel(key),
      value,
    }));

  return (
    <div className="member-card">
      <img src={member.portrait} alt={member.name} className="member-portrait" />
      <br />
      <h3 className="member-name">{member.name}</h3>

      {/* Health (special bar) */}
      {typeof member.health === "number" && (
        <div className="stat health" data-label="Health">
          <span className="label">Health</span>
          <div className="bar">
            <div className="fill" style={{ width: `${member.health}%` }} />
          </div>
          <span className="value">{member.health} / 100</span>
        </div>
      )}

      {/* Dynamic stats */}
      {stats.map((stat, index) => (
        <div
          key={stat.key}
          className={`stat stat-${stat.key.toLowerCase()}`}
          data-index={index}
          data-label={stat.label}
        >
          <span className="label">
     {stat.label}
          </span>
          <span className="value">{stat.value}</span>
        </div>
      ))}

      <br />
      <p>{member.bio}</p>
    </div>
  );
}
